var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-content wrapper-content--fixed"},[_c('section',[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"title"},[_vm._v("Нет такой страницы!")]),_vm._v(" "),_c('p',[_vm._v("Перейти "),_c('router-link',{staticClass:"link",attrs:{"to":{ name: 'main' }}},[_vm._v("на главную?")])],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }